const de = {
    countryChooser: {
        welcome: "Willkommen auf bardiauto.eu!",
        yourWebshop: "Die Preisinformationen und Werbeangebote finden Sie auf den regionalen Webseiten.",
        chooseAnotherCounrtry: "Bitte, wählen Sie das Land aus, in dem Sie sich befinden, damit wir Ihnen die " +
            "entsprechende Webseite zum Surfen und zum Aufgeben von Bestellungen zur Verfügung stellen können.",
        hu: "Ungarn",
        ro: "Rumänien",
        sk: "Slowakei"
    }
};

const texts = {
    en: {
        countryChooser: {
            welcome: "Welcome to bardiauto.eu!",
            yourWebshop: "The pricing information and promotional offers can be found on the regional websites.",
            chooseAnotherCounrtry: "Please select the country in which you are located, so that we can serve you the " +
                "appropriate website for you to browse and place orders through.",
            hu: "Hungary",
            ro: "Romania",
            sk: "Slovakia"
        }
    },
    de: de,
    'de-DE': de,
    'de-AT': de,
    'de-LI': de,
    'de-CH': de,
    'de-LU': de,
    locale: 'en',
    fallbackLocale: 'en',
    getLocale: ['hu', 'ro', 'sk'],
    tryAxios: false,

    install(vue) {
        vue.mixin({

            methods: {
                $t(key) {
                    let val = texts[texts.fallbackLocale];

                    if (texts[texts.locale]) {
                        val = texts[texts.locale];
                    }

                    key.split(".").forEach(element => {
                        if (element && val[element]) {
                            val = val[element];
                        }
                    });

                    if (typeof val !== 'string') {
                        val = texts[texts.fallbackLocale];
                        key.split(".").forEach(element => {
                            if (element && val[element]) {
                                val = val[element];
                            }
                        });
                    }

                    return val;
                },
                loadLang(callableFunction) {
                    if (texts.tryAxios === false && texts.getLocale.includes(texts.locale)) {
                        this.$store.commit("setIsLoading", true);
                        texts.tryAxios = true;
                        let url = "";
                        const loc = texts.locale === 'hu' ? (process.env.NODE_ENV === "development" ? '.' + texts.locale : '.' + texts.locale) : '.' + texts.locale;
                        const devUrl = process.env.NODE_ENV === "development" ? `https://www.bardiauto${loc}/webshop/javascript/application-lang` : `https://www.bardiauto${loc}/webshop/javascript/application-lang`;
                        url = process.env.NODE_ENV === "development" ? devUrl : devUrl;

                        if (url) {
                            this.axios.get(url).then(response => {
                                const e = "function appLang() { " + response.data + "; return appLang;} appLang();"
                                try {
                                    const appLang = eval(e);
                                    texts[texts.locale] = appLang;
                                    this.isLoading = true;
                                } catch (e) {
                                    texts.locale = texts.fallbackLocale;
                                }
                                this.$store.commit("setIsLoading", false);
                                if (typeof callableFunction === 'function') {
                                    callableFunction(texts.locale);
                                }
                            }).catch(() => {
                                texts.locale = texts.fallbackLocale;
                                this.$store.commit("setIsLoading", false);
                                if (typeof callableFunction === 'function') {
                                    callableFunction(texts.locale);
                                }

                            });
                        } else {
                            this.$store.commit("setIsLoading", false);
                            if (typeof callableFunction === 'function') {
                                callableFunction(texts.locale);
                            }

                        }
                    }
                },
            },
        })
    }
};

export default texts